 // Function to check the scroll position
        function checkScroll() {
            const headerMiddleLeft = document.querySelector('.header--middle-left');
            if (window.scrollY > 0) { // Check if the scroll position is greater than 0
                headerMiddleLeft.classList.add('scrolled');
            } else {
                headerMiddleLeft.classList.remove('scrolled');
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', checkScroll);